import { Box, List, Text } from '@redbubble/design-system';
import { kebabCase } from 'lodash';
import { ProductStyleSelectorItem } from './ProductStyleSelectorItem';
import styles from './ProductStyleSwitcher.module.scss';
import type { ProductStyleData } from './useProductSwitchData';

export interface ProductStylesListProps {
  currentProductTypeId: string;
  currentProductTypeGACode: string;
  productStyles: ProductStyleData[];
  title?: string;
}

export const ProductStylesList = ({
  currentProductTypeId,
  currentProductTypeGACode,
  productStyles,
  title,
}: ProductStylesListProps) => {
  const titleId = title
    ? `product-styles-list-${kebabCase(title.toLowerCase())}`
    : '';

  return (
    <>
      {title && (
        <Box marginBottom="xxs">
          <Text className={styles.listTitle} type="display5" id={titleId}>
            {title}
          </Text>
        </Box>
      )}
      <List aria-labelledby={titleId}>
        {productStyles.map((style) => {
          if (!style.productPageUrl) {
            return null;
          }

          return (
            <ProductStyleSelectorItem
              key={style.productTypeId}
              active={style.productTypeId === currentProductTypeId}
              description={style.description}
              longDescription={style.longDescription}
              previewImageUrl={style.previewImageUrl}
              matureContent={style.matureContent}
              descriptionTextType="display6"
              longDescriptionTextType="caption"
              price={style.price}
              productPageUrl={style.productPageUrl}
            />
          );
        })}
      </List>
    </>
  );
};
